// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__2pmGX","upload":"Small_upload__3mznz","imageWrap":"Small_imageWrap__tP6-X","removeBtn":"Small_removeBtn__2FOuC"};